import { all, call, CallEffect, fork, put, PutEffect, takeEvery, } from "redux-saga/effects";
import { ActionTypes } from "../../constants/ActionTypes";
import { fetchReceiversListSuccess, fetchConatctsSuccess } from "../actions";
import { ShowError } from "../../helper/Alert";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

const getReceiversList = async (str: string | null) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`person/getLetterReceivers?letterCodes[]=r696441&searchText=${str || ""}`);
}
const getContacts = async (params: any) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`Contact/GetContacts?q=${params.q}&page=${params.page}&contactType=${params.contactType}`);
}

//********************CONATCTS********************

function* fetchContactsRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedConatcts = yield call(getContacts, action.payload);
        yield put(fetchConatctsSuccess(fetchedConatcts.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchConatcts() {
    yield takeEvery(ActionTypes.GET_CONTACTS, fetchContactsRequest);
}
//***********************************************

function* fetchreceiversListRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedReceiversList = yield call(getReceiversList, action.payload);
        yield put(fetchReceiversListSuccess(fetchedReceiversList.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchReceiversList() {
    yield takeEvery(ActionTypes.GET_RECEIVERS_LIST, fetchreceiversListRequest);
}


//***************************************
export default function* rootSaga() {
    yield all([
        fork(fetchReceiversList),
        fork(fetchConatcts)
    ]);
}
